import $ from 'jquery';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { helpers } from '@bingads-webui/projection-grid-toolbar';
import { sortableHeaderTemplate } from '@bingads-webui-campaign/summary-grid-helper';

import { getColumnsConfig } from './columns/index';

const stateManager = globalContext.require('StateManager/CampaignStateManager');
const preferenceService = globalContext.requireDefault('component/preference/service/index');
const appConfig = globalContext.require('component/config/index');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/keywords-tab');

const { singleToolbarHeadRows } = helpers;

export function getConfig({
  dataSource,
  scope,
  gridView,
  customHeaderOffset,
  filterService,
  isForVNext,
  viewport,
}) {
  const tableName = i18n.getString('SharedLibrary_NegativeKeyword_Subtab');

  return {
    name: 'summary_tab_negative_keyword_list',
    legacyGridName: 'NegativeKeywordLibraryCampaignAssociationsGrid',
    tableClasses: ['table', 'table-bordered'],
    tableAttributes: { 'aria-label': tableName },
    dataSource,
    selection: true,
    rows: {
      headRows:
        isForVNext
          ? [
            'column-header-rows',
          ]
          : singleToolbarHeadRows(),
    },
    columns: getColumnsConfig({
      options: {
        i18n,
        scope,
        gridView,
        isForVNext,
      },
    }),
    scrolling: {
      header: {
        type: 'sticky',
        offset: customHeaderOffset || (() => $('.sticky-container').height()),
        attributes: { 'aria-label': i18n.getString('{{tableName}} table header', { tableName }) },
      },
      virtualized: true,
      viewport,
    },
    filterService,
    stateManager,
    preferenceService,
    config: appConfig,
    sortableHeader: {
      template: sortableHeaderTemplate,
    },
    i18n,
  };
}
